
import axios from './axios';

export const login = async (username, password) => {
    try {
        const res = await axios.post('login', {
            username,
            password,
        });

        if (res && res.data && res.data.user) {
            localStorage.setItem('user', res.data.user.username);
            localStorage.setItem('isSuperUser', res.data.user.isSuperUser);
            localStorage.setItem('role', JSON.stringify(res.data.user.role));
            localStorage.setItem('userType', res.data.user.userType);
            localStorage.setItem('sessionId', res.data.sessionId);
            return { data: { user: res.data.user['username'] , error: null }};
        } else {
            return { error: 'User Not Authorized', data: null }
        }
    } catch (error) {
        console.error("Login error:", error);
        return { data: null, error: error }
    }
};

// export const logout = async() => {
//     try {
//       localStorage.clear();
//     } catch (error) {
//       localStorage.clear();
//     } 
//   };

export const logout = async () => {
  try {
    const sessionId = localStorage.getItem('sessionId');

    if (sessionId) {
      await axios.post('logout', { sessionId });
    }

    localStorage.clear();

  } catch (error) {
    console.error("Logout error:", error);
    localStorage.clear();
  }
};
  